/* global axios */
import ApiClient from './ApiClient';

class RecentSearchesAPI extends ApiClient {
  constructor() {
    super('contacts', { accountScoped: true });
  }

  basePath(contactId) {
    return `${this.url}/${contactId}/recent_searches`;
  }

  get(contactId) {
    return axios.get(this.basePath(contactId));
  }

  create(contactId, payload) {
    return axios.post(this.basePath(contactId), payload);
  }

  delete(contactId, id) {
    return axios.delete(`${this.basePath(contactId)}/${id}`);
  }
}

export default new RecentSearchesAPI();
